export default {
  'Extract audio': 'استخراج الصوت',
  'Mute': 'كتم',
  'Split video and audio': 'تقسيم الفيديو والصوت',
}